import React from 'react';
import classNames from 'classnames';

import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import WarningIcon from 'housecall-ui/dist/IconsAndImages/Icons/Warning';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

type BannerProps = {
  className?: string;
  onClick?: () => void;
}

type WarningBarProps = {
  message: string | JSX.Element;
  hasHeader?: boolean;
  bannerProps?: BannerProps;
}

const useStyles = makeStyles((theme: HCPTheme) => ({
  container: {
    backgroundColor: theme.palette.alert.light,
    position: 'relative',
    top: 8,
  },
  header: {
    padding: 2,
    backgroundColor: theme.palette.alert.main,
  },
  body: {
    verticalAlign: 'center',
    paddingRight: 24,
  },
}));

const WarningBar = ({ hasHeader, message, bannerProps }: WarningBarProps) => {
  const classes = useStyles();
  const { className, ...rest } = bannerProps || {};

  return (
    <HousecallThemeProvider>
      <Grid
        container
        alignItems="center"
        {...rest}
        className={classNames(className, classes.container)}
      >
        {hasHeader && <Grid item xs={12} className={classes.header} />}
        <Grid item style={{ paddingLeft: 24 }}>
          <WarningIcon color="alert" size="large" />
        </Grid>
        <Grid item xs className={classes.body}>
          <Typography variant="body2">
            {message}
          </Typography>
        </Grid>
      </Grid>
    </HousecallThemeProvider>
  );
};

export default WarningBar;
